import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Card, CardText } from "reactstrap";
import style, { StyledCardImage, StyledCardTitle } from "./style";

const BlogItem = ({ item }) => {
  const img =
    item.thumbnail_images && item.thumbnail_images.full
      ? item.thumbnail_images.full.url
      : "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=";
  if (item) {
    return (
      <Card
        key={item.id}
        style={style.cardView}
        className="lg:w-[45%] md:text-sm lg:text-md xs:text-sm h-fit xl:text-lg"
      >
        <div className="relative w-full max-w-md xs:max-w-full">
          <StyledCardImage src={img} style={style.cardChild} />
          <div className="flex absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white  text-lg font-bold-100 p-1">
            <div className="w-2 rounded-sm bg-header mr-2"></div>
            <StyledCardTitle className="text-sm sm:text-lg md:text-lg">
              {" "}
              {item.title}
            </StyledCardTitle>
          </div>
        </div>

        {/* {img ==
          "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=" && (
          <div className="relative w-full max-w-md xs:max-w-full">
            <StyledCardImage src={img} style={style.cardChild} />
            <div className="flex absolute bottom-0 left-0 w-full bg-black bg-opacity-50 text-white  text-lg font-bold-100 p-1">
              <div className="w-2 rounded-sm bg-header mr-2"></div>
              <StyledCardTitle className="text-sm sm:text-lg md:text-lg">
                {" "}
                {item.title}
              </StyledCardTitle>
            </div>
          </div>
        )} */}

        <div className="px-3 py-4 font-satoshi text-black font-medium">
          <CardText
            dangerouslySetInnerHTML={{ __html: item.excerpt }}
          ></CardText>
          <style>
            {`
    .more-link {
      color: rgb(25 173 228 / var(--tw-bg-opacity, 0.7)) !important;
      padding: 0px 0px 0px 10px;
    }
          .more-link:hover {
      color: rgb(25 173 228 / var(--tw-bg-opacity, 1)) !important;
    }
  `}
          </style>
        </div>
      </Card>
    );
  }
  return <div />;
};

export default BlogItem;
